// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sedi/:id/condizioni/:tipoDocumento',
    requestBody: null,
    response: '{ sede: SedeInfo, condizione: Condizione | null }'
  },
  {
    method: 'PUT',
    endpoint: '/api/sedi/:id/condizioni/:tipoDocumento',
    requestBody: '{"testoHtml":"string"}',
    response: '{ ok: true, condizione: Condizione }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
